import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { getLanguage } from '@/shared/lib/i18n';
import { AddressesDto, AddressAutocompleteMode } from '../model';

class AddressClient extends BaseClient {
  getAddress({ search, mode }: { search: string; mode?: AddressAutocompleteMode }): AxiosPromise<AddressesDto> {
    const language = getLanguage();
    const payload: { text: string; language: string; mode?: AddressAutocompleteMode } = {
      text: search,
      language: language === 'nl' ? 'nl-NL' : 'en-US',
    };

    if (mode) {
      payload.mode = mode;
    }

    return this.request({
      url: `${hosts.searchApi}/address_autocomplete`,
      method: 'POST',
      data: payload,
    });
  }
}

export const addressClient = new AddressClient();
